import moment from 'moment'
import sort from 'fast-sort'
const state = () => ({
    loading: false,
    error: null,
    active_year: '',
    chartVals: {
        pieChartVals: [],
        barChartVals: {
            sales: [], //sale stats for barchart rendering
            profits: [] //profits chart for barchart rendering
        },
    },
    otherVals: {
        tot_sales_today: 0,
        all_time_trans_count: 0,
        total_stock_items: 0,
        high_demand: [],
        low_demand: [],
        high_earning: [],
        low_earning: [],
        daily_trans: [],
        trans_by_days: [],
        trans_by_months: [],
        trans_by_years: []
    },


})

const actions = {
    set_year({ commit }, val) {
        commit('Active_Year', val);
    },

    set_chartvals({ commit, state }, data) {
        let sales = data.sales

        const filteredSales = sales.filter(x => { return (new Date(x.created_at).getFullYear() == parseInt(state.active_year)) })

        const groupedFilteredSalesInMop = filteredSales.length > 0 ? filteredSales.reduce((groups, item) => ({ //grouped sales items according to mode of payment
            ...groups,
            [item.mop]: [...(groups[item.mop] || []), item]
        }), []) : []

        const groupedFilteredSalesInMonths = filteredSales.length > 0 ? filteredSales.reduce((groups, item) => ({ //grouped sales items according to months
            ...groups,
            [new Date(item.created_at).getMonth()]: [...(groups[new Date(item.created_at).getMonth()] || []), item]
        }), []) : []

        //console.log("mopooooo", groupedFilteredSalesInMop)
        //console.log("maaaatuuuuuuu", groupedFilteredSalesInMonths)

        var cv = {
            pieChartVals: [],
            barChartVals: {
                sales: [], //sale stats for barchart rendering
                profits: [] //profits chart for barchart rendering
            },
        };


        //calculating cash and credit mode of payment percentages to draw bar chart
        if (groupedFilteredSalesInMop) {
            var cash_mop = typeof(groupedFilteredSalesInMop.Cash) !== 'undefined' ? groupedFilteredSalesInMop.Cash.length : 0;
            var credit_mop = typeof(groupedFilteredSalesInMop.Credit) !== 'undefined' ? groupedFilteredSalesInMop.Credit.length : 0;
            var total_mop = parseInt(cash_mop) + parseInt(credit_mop)

            var cash_perc = (cash_mop / total_mop) * 100;
            var credit_perc = (credit_mop / total_mop) * 100;

            cv.pieChartVals = [parseFloat(cash_perc).toFixed(2), parseFloat(credit_perc).toFixed(2)]
        } else {
            cv.pieChartVals = []
        }


        //setting monthly sales to draw barchart
        var i;
        for (i = 0; i < 12; i++) {
            var monthSales = groupedFilteredSalesInMonths[i];

            if (typeof(monthSales) === 'undefined') {
                cv.barChartVals.sales.push(0)
                cv.barChartVals.profits.push(0)
            } else {
                var ttl_sale_sum = monthSales.reduce((sum, val) => sum + parseFloat(val.payable_amount), 0)
                var ttl_prod_price_sum = monthSales.reduce((sum, val) => {

                    const c = val.items.reduce((a, b) => a + parseFloat(b.pur_price * b.squantity), 0);
                    return sum + c;


                }, 0)

                // console.log("valatimmooooo", ttl_prod_price_sum)

                var profit = parseFloat(ttl_sale_sum) - parseFloat(ttl_prod_price_sum) //difference between sale sum and product actual price sum is profit

                cv.barChartVals.sales.push(parseFloat(ttl_sale_sum).toFixed(2))
                cv.barChartVals.profits.push(parseFloat(profit).toFixed(2))
            }

        }

        commit('Chart_Vals', cv);

    },
    set_othervals({ commit, rootGetters, dispatch }, data) {
        var ov = {
            tot_sales_today: 0,
            all_time_trans_count: 0,
            total_stock_items: 0,
            high_demand: [],
            low_demand: [],
            high_earning: [],
            low_earning: [],
            daily_trans: [],
            trans_by_days: [],
            trans_by_months: [],
            trans_by_years: []
        };

        
        var stockItems = data.stock_items
        var sales = data.sales
        var saleItems = data.sales_items
        var today = new Date();

        //setting values
        if (sales && saleItems && stockItems) {

            const groupedSaleItems = saleItems.reduce((groups, item) => ({ //grouped sales items 
                ...groups,
                [item.transaction_id]: [...(groups[item.transaction_id] || []), item]
            }), []);


            const groupedSalesByDate = sales.reduce((groups, sale) => ({ //grouped sales items
                ...groups,
                [moment(new Date(sale.created_at)).format('DD MMM, YYYY')]: [...(groups[moment(new Date(sale.created_at)).format('YYYY-MM-DD')] || []), sale]
            }), {});


            let groupedSalesByDay = sales.reduce((groups, sale) => ({ //grouped sales items
                ...groups,
                [new Date(sale.created_at).getDay()]: [...(groups[new Date(sale.created_at).getDay()] || []), sale]
            }), {});

            //console.log("gssdddd",groupedSalesByDay)




            const groupedSalesByMonth = sales.reduce((groups, sale) => ({ //grouped sales items
                ...groups,
                [new Date(sale.created_at).getMonth()]: [...(groups[new Date(sale.created_at).getMonth()] || []), sale]
            }), {});

            const groupedSalesByYear = sales.reduce((groups, sale) => ({ //grouped sales items
                ...groups,
                [new Date(sale.created_at).getFullYear()]: [...(groups[new Date(sale.created_at).getFullYear()] || []), sale]
            }), {});

            const stock = stockItems.map(x => x);

            // console.log('sssrrttttttt', stock)

            //console.log('tyyyyypppee', typeof(parseInt(stock[0].sales_count)))

            //let Demands = stock.sort((a, b) => parseInt(a.sales_count) - parseInt(b.sales_count))


            //let Earnings = stock.sort((a, b) => a.sale_sum_count - b.sale_sum_count)

            let Demands = sort([...stock]).asc(s => parseInt(s.sales_count))

            let Earnings = sort([...stock]).asc(s => parseFloat(s.sale_sum))

            


            ov.all_time_trans_count = sales.length
            ov.total_stock_items = stockItems.length;
            ov.tot_sales_today = sales.filter((x) => {
                return moment(new Date(x.created_at)).format('YYYY-MM-DD') == moment(new Date(today)).format('YYYY-MM-DD')
            }).length
            ov.high_demand = Demands.slice(-5).reverse()
            ov.low_demand = Demands.slice(0, 5)
            ov.high_earning = Earnings.slice(-5).reverse()
            ov.low_earning = Earnings.slice(0, 5)
            ov.daily_trans = Object.keys(groupedSalesByDate).map((key) => {
                //console.log("gsallles", groupedSalesByDate)
                var sod = groupedSalesByDate[key]
                    //console.log("gsalllesiii", sod)

                var isos = sod.reduce((sum, val) => {
                        let c = val.items.reduce((sum, val) => { return sum + val.squantity }, 0)
                        return sum + c
                    }, 0) // (isos)items sold on  sale date

                var sale_stat = {
                    salesDate: key,
                    total_trans: sod.length,
                    qty_sold: isos,
                    ttl_earned: sod.reduce((sum, val) => parseFloat(val.payable_amount) + sum, 0)
                }

                return sale_stat
            }).slice(0, 10)

            // ov.daily_trans = sort([...ov.daily_trans]).asc(i => new Date(i.salesDate))

            ov.trans_by_days = Object.keys(groupedSalesByDay).map((key) => {
                var sod = groupedSalesByDay[key]
                var isos = sod.reduce((sum, val) => {
                        let c = val.items.reduce((sum, val) => { return sum + val.squantity }, 0)
                        return sum + c
                    }, 0) // (isos)items sold on sale on sale date

                var sale_stat = {
                    salesDay: key,
                    total_trans: sod.length,
                    qty_sold: isos,
                    ttl_earned: sod.reduce((sum, val) => parseFloat(val.payable_amount) + sum, 0)
                }

                return sale_stat
            }).slice(0, 7)


            ov.trans_by_months = Object.keys(groupedSalesByMonth).map((key) => {
                var sod = groupedSalesByMonth[key]
                var isos = sod.reduce((sum, val) => {
                        let c = val.items.reduce((sum, val) => { return sum + val.squantity }, 0)
                        return sum + c
                    }, 0) // (isos)items sold on sale on sale date

                var sale_stat = {
                    salesMonth: key,
                    total_trans: sod.length,
                    qty_sold: isos,
                    ttl_earned: sod.reduce((sum, val) => parseFloat(val.payable_amount) + sum, 0)
                }

                return sale_stat
            }).slice(0, 12)

            ov.trans_by_years = Object.keys(groupedSalesByYear).map((key) => {
                var sod = groupedSalesByYear[key]
                var isos = sod.reduce((sum, val) => {
                        let c = val.items.reduce((sum, val) => { return sum + val.squantity }, 0)
                        return sum + c
                    }, 0) // (isos)items sold on sale on sale date

                var sale_stat = {
                    salesYear: key,
                    total_trans: sod.length,
                    qty_sold: isos,
                    ttl_earned: sod.reduce((sum, val) => parseFloat(val.payable_amount) + sum, 0)
                }

                return sale_stat
            }).slice(0, 10)

            //console.log('ovvvvv', ov.high_demand)
                // return;
            commit('Other_Vals', ov);

        }

    },
    set_loading({ commit }, val) {
        commit('Loading', val)
    }


}


const mutations = {

    Loading(state, val) {
        state.loading = val;
    },
    Active_Year(state, val) {
        state.active_year = val;
    },
    //chart mutations
    Chart_Vals(state, vals) {

        state.chartVals = vals
    },
    //other mutations
    Other_Vals(state, val) {
        state.otherVals = val
    },

}

const getters = {
    //getting analytics
    CHARTVALS(state) { //getting current barchart values in store
        return state.chartVals;
    },
    OTHERVALS(state) { //getting current piechart values in store
        return state.otherVals
    },
    DASH_LOADING(state) {
        return state.loading
    }
}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}